import { Vue, Component, toNative } from 'vue-facing-decorator';
import CrossSellTable from 'components/CrossSellTable';
import { useRouter } from 'vue-router';
import Template from './template.vue';

@Component({
	components: {
		CrossSellTable,
	},
	mixins: [Template],
})
class CrossSell extends Vue {
	private router = useRouter();

	protected showModal(): void {
		this.$root?.$emit(
			'bv::show::modal',
			'crossSell-modal',
			'#crossSellShow',
		);
	}

	protected routeCrossSell(id: string): void {
		this.router.push(`/crosssell/${id}`);
	}
}

export default toNative(CrossSell);
